import BaseService from "../BaseService";
import _ from "lodash";

class FolderService extends BaseService {
    create = async ({ name, parent_id }) => {
        var image = this._api.post("folder/create", { name, parent_id })
        return image;
    };

    update = async ({ id, name, parent_id }) => {
        var image = this._api.post("folder/update", { id, name, parent_id })
        return image;
    };

    delete = async (id) => {
        var image = this._api.post("folder/delete", { id })
        return image;
    };

    list = async (folder) => {
        var image = this._api.post("folder/list")
        return image;
    };





}
export default FolderService;
